/**
 * @generated SignedSource<<62b9a9392e0947351b17a367fb3b830b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemTopicsCardItemTopic$data = {
  readonly entityId: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "itemTopicsCardItemTopic";
};
export type itemTopicsCardItemTopic$key = {
  readonly " $data"?: itemTopicsCardItemTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemTopicsCardItemTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemTopicsCardItemTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "de0b9335192979375d204d45c26419cc";

export default node;
